// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"473":"87f8521e","951":"273e26d4"}[chunkId] + ".chunk.js";
};